import { Button, Card, Col, Form, Input, message, Modal, Row } from "antd";
import { useState } from "react";

import { CreateAccountModal } from "./CreateAccountModal";
import img1 from "./img1.jpg";
import img2 from "./img2.jpg";

export function IntroPage(props: { onCreate: (username: string) => void }) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Card style={{ margin: 12 }}>
        <Row align="middle">
          <Col md={16} xs={24}>
            <Row>
              <div style={{ fontSize: 24, fontWeight: "bold" }}>Social media with guardrails</div>
            </Row>
            <Row>
              <p>Socialize with like- and unlike-minded people with peace of mind.</p>
              <p>
                Cancel™ uses advanced A.I. technology and blockchain to ensure the most effective content moderation on
                the internet.
              </p>
            </Row>
          </Col>
          <Col md={8} xs={24}>
            <Row align="stretch">
              <Form style={{ width: "100%" }} layout="horizontal">
                <Form.Item>
                  <Input placeholder="username" />
                </Form.Item>
                <Form.Item>
                  <Input.Password placeholder="password" />
                </Form.Item>
              </Form>
            </Row>
            <Row align="middle" justify="center">
              <Button
                onClick={() => {
                  Modal.error({
                    content: "Account not found.",
                  });
                }}
                type="primary"
              >
                Login
              </Button>
            </Row>
            <Row align="middle" justify="center" style={{ marginTop: 12 }}>
              <a onClick={() => setShowModal(true)}>create account</a>
            </Row>
          </Col>
        </Row>
      </Card>
      <Card style={{ margin: 12 }}>
        <Row gutter={12} align="middle">
          <Col md={{ span: 8, order: 1 }} xs={{ span: 24, order: 2 }}>
            <div
              style={{
                position: "relative",
                paddingBottom: "56.25%",
                paddingTop: "30px",
                height: 0,
                overflow: "hidden",
              }}
            >
              <iframe
                style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
                // style={{ width: 560, height: 315, maxWidth: "100%" }}
                src="https://www.youtube.com/embed/fxSdJY3WaKQ"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </Col>
          <Col md={{ span: 16, order: 2 }} xs={{ span: 24, order: 1 }}>
            <div style={{ fontSize: 18, fontWeight: "bold" }}>It's a Culture</div>
            <p>
              We at Cancel™ believe in respecting everyone. If you post anything—no matter the content—your account will
              be temporarily suspended. If you post after your account is reactivated, you will be permanently banned
              from the platform. Rest assured that your posts will nevertheless be saved on the Blockchain for all
              eternity.
            </p>
          </Col>
        </Row>
      </Card>
      <Card style={{ margin: 12 }}>
        <Row gutter={12} align="middle">
          <Col md={{ span: 16 }} xs={{ span: 24 }}>
            <div style={{ fontSize: 18, fontWeight: "bold" }}>Competitive Advantage</div>
            <p>
              Our A.I. driven approach to content moderation is far superior to those of our competitors. You cannot say
              anything wrong on Cancel™ because you cannot say anything on Cancel™. Our A.I. won't allow that.
            </p>
            <p>We've got your back.</p>
          </Col>
          <Col md={7} xs={24}>
            <Row align="middle" justify="center">
              <img src={img2} style={{ maxHeight: "100%", maxWidth: "100%" }} />
            </Row>
          </Col>
        </Row>
      </Card>
      {showModal ? <CreateAccountModal onCancel={() => setShowModal(false)} onCreate={props.onCreate} /> : null}
    </>
  );
}
